var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceWinkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4359 12.359C7.4359 12.359 8.6859 14.0256 10.7692 14.0256C12.8526 14.0256 14.1026 12.359 14.1026 12.359M13.2692 8.19231H13.2776M7.4359 8.19231H9.10256M19.1026 10.6923C19.1026 15.2947 15.3716 19.0256 10.7692 19.0256C6.16686 19.0256 2.4359 15.2947 2.4359 10.6923C2.4359 6.08994 6.16686 2.35898 10.7692 2.35898C15.3716 2.35898 19.1026 6.08994 19.1026 10.6923ZM13.6859 8.19231C13.6859 8.42243 13.4993 8.60898 13.2692 8.60898C13.0391 8.60898 12.8526 8.42243 12.8526 8.19231C12.8526 7.96219 13.0391 7.77564 13.2692 7.77564C13.4993 7.77564 13.6859 7.96219 13.6859 8.19231Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceWinkLight);
export default __webpack_public_path__ + "static/media/face-wink-light.bdecd18beeab7f7c6207de1cbae0f1e9.svg";
export { ForwardRef as ReactComponent };